import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';

// utils
import { noop } from '../../../../../utils/general';
import styles from './activityInfo.module.scss'

const NA_PLACEHOLDER = '-'

const renderContent = (activity) => (
  <div className={styles.tooltipContainer}>
    <div className={styles.tooltipItem}>
      <div className={styles.tooltipLabel}>Method:  </div>
      <div className={styles.tooltipValue}>{activity.method || NA_PLACEHOLDER}</div>
    </div>
    <div className={styles.tooltipItem}>
      <div className={styles.tooltipLabel}>Url:  </div>
      <div className={styles.tooltipValue}>{activity.url || NA_PLACEHOLDER}</div>
    </div>
    <div className={styles.tooltipItem}>
      <div className={styles.tooltipLabel}>Id:  </div>
      <div className={styles.tooltipValue}>{activity.id || NA_PLACEHOLDER}</div>
    </div>
    <div className={styles.tooltipItem}>
      <div className={styles.tooltipLabel}>Okta RequestId:  </div>
      <div className={styles.tooltipValue}>{activity.oktaRequestId || NA_PLACEHOLDER}</div>
    </div>
  </div>
)

const ActivityInfo = ({
  closeDialog,
  showDialog,
  activityInfo
}) => (
  <Dialog
    open={showDialog}
    onClose={closeDialog}
    onClick={(e) => e.stopPropagation()}
  >
    <DialogTitle className={styles.heading}>
      Activity Info
    </DialogTitle>
    <DialogContent className={styles.dialogBody}>
      {renderContent(activityInfo)}
    </DialogContent>
    <DialogActions className={styles.actions}>
      <Button
        onClick={closeDialog}
        type="submit"
        className={styles.cancelBtn}
        variant="contained"
      >
        Close
      </Button>
    </DialogActions>
  </Dialog>
  );

ActivityInfo.propTypes = {
  closeDialog: PropTypes.func,
  showDialog: PropTypes.bool,
  activityInfo: PropTypes.object,
};

ActivityInfo.defaultProps = {
  closeDialog: noop,
  showDialog: false,
  activityInfo: {},
};

export default ActivityInfo;
